jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

/*document.addEventListener('cartsectionschanged', function () {
    setFreeGiftItems(jQuery);
});

document.addEventListener('cartrefresh', function () {
    
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if(cart){
        let sections = cart.getSectionsToRender().map((section) => section.id);
        if(sections){
            fetch(`/?sections=${sections.join(',')}`)
            .then((response) => response.json())
            .then((response) => {
                let sections = {};
                sections.sections = response;
                cart.renderContents(sections, false);
            });
        }
    }

});*/

/**
 * imports
 */
import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
import './css/main.scss';
import './shopify.js';
import 'bootstrap/js/src/tab.js';
import BsubWidget from './js/bsubwidget.js';
import SubscriptionBuilder from './js/subscription-builder.js';
import SubscriptionModifier from './js/subscription-modifier.js';
import jQuery from 'jquery';
import 'jquery.marquee';
import Plyr from 'plyr';
import Hls from 'hls.js';
import Rellax from 'rellax';
import Drift from 'drift-zoom';
import fitty from 'fitty';
import 'arrive/src/arrive.js';
import Flickity from 'flickity';
import { LiveMap } from "./js/livemap.js";
import { LiveMapGallery } from "./js/livemapgallery.js";

// Sentry.init({
//   dsn: "https://d1c0c3d2d7ba41adb440d7c9bb96ab68@o4503982857584640.ingest.sentry.io/4503982862893056",
//   integrations: [new BrowserTracing()],
//   attachStacktrace: true,

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0.5,
// });

//window.jQuery = window.$ = jQuery;

// Create the observer
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    // If the element is visible
    if (entry.isIntersecting) {
      // Add the animation class
      entry.target.classList.add('is-inview');
      entry.target.classList.add('is-inview-active');
    }else{
      entry.target.classList.remove('is-inview-active');
    }
  });
});

document.querySelectorAll('.inview').forEach((elem) => {
    // Tell the observer which elements to track
    observer.observe(elem);
});

document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.inview').forEach((elem) => {
    // Tell the observer which elements to track
    observer.observe(elem);
});

    });


String.prototype.interpolate = function(params) {
  const names = Object.keys(params);
  const vals = Object.values(params);
  return new Function(...names, `return \`${this}\`;`)(...vals);
}

function throttle(fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}

function setHeaderBottom(){

    if(window.mobileCheck()){ document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`); }
    var header = document.getElementById('shopify-section-header');
    var borderOffset = 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom - borderOffset)}px`);

}

(function() {
  fitty('span.fitty');
})();

document.addEventListener('shopify:section:load', () => {
  fitty('span.fitty')
});

window.addEventListener('resize', () => {
  fitty('span.fitty');
});

let headerOffsetTop = 0;
let headerOuterHeight = 0;
let subscriptionProgressOffsetTop = 0;
let subscriptionProgressHeight = 0;
if (jQuery('.section-subscription-progress').length > 0) {
    jQuery('.section-subscription-progress').before('<div class="section-subscription-progress-anchor"></div>');

    headerOffsetTop = jQuery('#shopify-section-header').offset().top;
    headerOuterHeight = jQuery('#shopify-section-header').outerHeight();
    subscriptionProgressOffsetTop = jQuery('.section-subscription-progress').offset().top;
    subscriptionProgressHeight = jQuery('.section-subscription-progress').outerHeight();
}
function subscriptionPageStickyHeader() {
    subscriptionProgressOffsetTop = jQuery('.section-subscription-progress-anchor').offset().top;
    if (jQuery('.section-subscription-progress').length > 0 && jQuery(window).width() <= 575.98) {
        if (jQuery(window).scrollTop() >= headerOffsetTop) {
            jQuery('#shopify-section-header').addClass('past-offset');
            jQuery('html').css('padding-top', headerOuterHeight + 'px' );
        } else {
            jQuery('#shopify-section-header').removeClass('past-offset');
            jQuery('html').css('padding-top', '0' );
        }

        if (jQuery(window).scrollTop() >= subscriptionProgressOffsetTop - headerOuterHeight) {
            jQuery('.section-subscription-progress-anchor').css('height', subscriptionProgressHeight);
            jQuery('.section-subscription-progress').addClass('past-offset').css('top', headerOuterHeight + 'px');
        } else {
            jQuery('.section-subscription-progress-anchor').css('height', 0);
            jQuery('.section-subscription-progress').removeClass('past-offset').css('top', 'unset');
        }
    }
}

jQuery(document).ready(($) => {

    $('.announcement').each(function(){

        if($(this).attr('data-scrollspeed') > 0){

            $(this).marquee({
                duplicated: true,
                gap: window.innerWidth,
                duration: window.innerWidth > 800 ? parseInt($(this).attr('data-scrollspeed')) : parseInt($(this).attr('data-scrollspeed')/3)
            });

        }
        
    });

    if ($('.bg-video').length) {
        $('.bg-video').each(function () {

            let video = $(this)[0];

            const player = new Plyr(video, {
                muted: true,
                storage: { enabled: false },
                // autoplay: true,
                loop: { active: true },
                fullscreen: {
                    enabled: true,
                    iosNative: false
                },
                controls: [],
                vimeo: { 
                    muted: 1,
                    autoplay: 1,
                    autopause: 0,
                    loop: 1,
                    byline: 0,
                    title: 0,
                    sidedock: 0, 
                    controls: 0,
                    background: 1
                } 
            });

            player.elements.container.style.height = '0';
           
            player.on('ready', () => {
                setTimeout(() => {
                    // player.muted = true;
                    player.elements.container.style.height = 'auto';
                }, 0);
                var x = 0;
                var intervalID = setInterval(function () {
                    player.muted = true;
                    player.play();

                    if (++x === 10) {
                        window.clearInterval(intervalID);
                    }
                }, 500);
            });

            player.on('playing', () => {
                setTimeout(() => {
                    player.elements.container.style.height = 'auto';
                }, 100)
            });

        });
    }

    if ($('.video').length) {
        $('.video').each(function () {

            let video = $(this)[0];

            const player = new Plyr(video, {
                controls: ['play'],
                vimeo: { 
                    sidedock: 0, 
                    controls: 0
                } 
            });

        });
    }

    if($('.rellax').length > 0){
        new Rellax('.rellax', {
            breakpoints: [576, 768, 1201],
            //relativeToWrapper: true
            //center: true
        });
    }

    $('.micro-add-to-cart .minus').click(function () {
        const currentVal = parseInt($(this).closest('.micro-add-to-cart').find('input[type="number"]').first()
            .val(), 10);

        if (!isNaN(currentVal) && currentVal > 1) {
            $(this).closest('.micro-add-to-cart').find('input[type="number"]').first()
                .val(currentVal - 1)
                .trigger('change');
        }
    });

    $('.micro-add-to-cart .plus').click(function () {
        const currentVal = parseInt($(this).closest('.micro-add-to-cart').find('input[type="number"]').first()
            .val(), 10);

        if (!isNaN(currentVal)) {
            $(this).closest('.micro-add-to-cart').find('input[type="number"]').first()
                .val(currentVal + 1)
                .trigger('change');
        }
    });

    // $('.micro-add-to-cart').submit(function(e){

    //     e.preventDefault();

    // })

    $('.product__nutritional_info .button').click(function(){
        $(this).fadeOut().siblings('.rte').show().slideDown();
        return true;
    })

    $('.map-fluid').click(function(e) {
        $(this).find('iframe').css('pointer-events', 'all');
    }).mouseleave(function(e) {
        $(this).find('iframe').css('pointer-events', 'none');
    });

    $('.mesa-form').each(function(){

        var form = $(this);

        var maximum_total = form.attr('data-maximum');
        var maximum_daily = form.attr('data-maximum-daily');
        var maximum_reset = form.attr('data-daily-reset');
        var maximum_mssge = form.attr('data-message');
        var maximum_redir = form.attr('data-redirect');
        var maximum_table = form.attr('data-table');
        var unique_email = form.attr('data-unique-email');
        var unique_phone = form.attr('data-unique-phone');
        var unique_address = form.attr('data-unique-address');

        const submissionscheck = new URL("https://forms.jimmysicedcoffee.com/.netlify/functions/formcheck");
        submissionscheck.searchParams.append("form", maximum_table);
        if(maximum_reset) submissionscheck.searchParams.append("time", maximum_reset);

        const url = submissionscheck.href;

        if(maximum_total !== "" || maximum_daily !== ""){

            $.get( { url: url, dataType: 'json' }, function( data ) {

                //console.log(data.total, maximum_total, data.today, maximum_daily)
                
                if(parseInt(data.total) < parseInt(maximum_total) && parseInt(data.today) < parseInt(maximum_daily)){
                    console.log('form showing');
                    form.show();
                }else if(maximum_mssge){
                    console.log('form error message');
                    form.html(`<div class="alert alert-warning">${maximum_mssge.replace(/(?:\r\n|\r|\n)/g, '<br /><br />')}</div>`);
                    form.show();
                }else if(maximum_redir){
                    console.log('form redirecting');
                    if (!Shopify.designMode) {
                        window.location.href = maximum_redir;
                    }
                }else{
                    console.log('no matching conditions');
                }

        });

        }else{

            form.show();

        }

    });

    $('.mesa-forms').submit(function(e){

        e.preventDefault(); // avoid to execute the actual submit of the form.

        var form = $(this);
        var formdata = $(this).serialize();
        var method = $(this).attr('method');
        var action = $(this).attr('action');

        console.log(formdata, method, action);

        $.ajax({
            type: method,
            url: action,
            data: formdata, // serializes the form's elements.
            success: function(data)
            {

                var success = '<h3 class="text-center">On it\'s way!</h3><p>If you have an account with that email address, you\'ll recieve an email with a link to activate your account. If it doesn\'t arrive within a couple of minutes, please check your spam or junk folder.<br /><br /><a href="/a/account">Back to login</a></p>';
                $('.rendered-form').html(success); // show response from the php script.
            }
        });

        return false;

    });

    init($);
    // cartUpdate($);

    // document.addEventListener('cartchanged', function () {
    //     cartUpdate($);
    // });

    // Create an observer instance
    var observer = new MutationObserver(function( mutations ) {
      mutations.forEach(function( mutation ) {
        var newNodes = mutation.addedNodes; // DOM NodeList
        if( newNodes !== null ) { // If there are new nodes added
            newNodes.forEach(function(newNode) {
                if($(newNode).hasClass('active-subscription')){
                    if($(newNode).find('.paused-label').length > 0){
                        $(newNode).addClass('is-paused');
                    }
                }
                if($(newNode).is("p") && $(newNode).text() == 'Customer has no active subscriptions.'){
                    $(newNode).text('You don\'t have any active subscriptions at the moment.');
                }
                if($(newNode).hasClass('stx-field--with-radio-field')){
                    $(newNode).find('.stx-radio-field__label').text($(newNode).find('.stx-radio-field__label').text().replace('Only update next order dates', 'Create additional order (This will not affect your existing subscription renewals)'));
                    $(newNode).find(':radio').prop('name', 'next_order_setting');
                    $(newNode).find(':radio[value="all_future_orders"]').trigger('click');
                }
                if($(newNode).hasClass('panel--section') && $(newNode).parents('.products-panel-wrap').length > 0){
                    let subscription_id = $(newNode).parents('.active-subscription').first().attr('data-bold-subscription-id');
                    $(newNode).prepend(`<div class="p-3 color-background-2 text-center">To make changes to your subscription, please <a href="/pages/modify-subscription?id=${subscription_id}" target="_blank" class="with-button mx-2">click here</a></div>`)
                }
                if($(newNode).hasClass('dismissible-message-container')){
                    setTimeout(function(){ $(newNode).remove(); }, 8000);
                }
            });
        }
      });    
    });

    if($('#customer-portal-root').length > 0){

        observer.observe($('#customer-portal-root')[0], { 
            attributes: true, 
            childList: true, 
            characterData: true,
            subtree: true
        });

        $('#customer-portal-root').on('click', '.stx-button', function(){

            if(['view inactive subscriptions', 'hide inactive subscriptions'].includes($(this).find('.stx-button__text')[0].innerText.toLowerCase())){

                $([document.documentElement, document.body]).animate({
                    scrollTop: $('.subscriptions-container').first().offset().top-100
                }, 500);

            }

        })

    }

    if($('.flexible-content-block-content-product-list.is-slider').length > 0){
        $('.flexible-content-block-content-product-list.is-slider > .row').each(function(){

            /** Flickity Slider **/
            let tickerSpeed = 1;

            if($( window ).width() < 576) {
                tickerSpeed = 0.5;
            }

            let flickity = null;
            let isPaused = false;
            const slideshowEl = document.querySelector('.flexible-content-block-content-product-list.is-slider > .row');


            //
            //   Functions
            //
            //////////////////////////////////////////////////////////////////////

            const update = () => {
                if (isPaused) return;
                if (flickity.slides) {
                    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
                    flickity.selectedIndex = flickity.dragEndRestingSelect();
                    flickity.updateSelectedSlide();
                    flickity.settle(flickity.x);
                }
                window.requestAnimationFrame(update);
            };

            const pause = () => {
                isPaused = true;
            };

            const play = () => {
                if (isPaused) {
                    isPaused = false;
                    window.requestAnimationFrame(update);
                }
            };


            //
            //   Create Flickity
            //
            //////////////////////////////////////////////////////////////////////

            flickity = new Flickity(slideshowEl, {
                autoPlay: false,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                wrapAround: true,
                selectedAttraction: 0.015,
                friction: 0.25,
                accessibility: false,
                resize: false
            });
            flickity.x = 0;


            //
            //   Add Event Listeners
            //
            //////////////////////////////////////////////////////////////////////

            slideshowEl.addEventListener('mouseenter', pause, false);
            slideshowEl.addEventListener('focusin', pause, false);
            slideshowEl.addEventListener('mouseleave', play, false);
            slideshowEl.addEventListener('focusout', play, false);

            flickity.on('dragStart', () => {
                isPaused = true;
            });

            flickity.on('dragEnd', function( event, pointer ) {
                if($( window ).width() < 576){
                    if (isPaused) {
                        isPaused = false;
                        window.requestAnimationFrame(update);
                    }
                }
            });

            //
            //   Start Ticker
            //
            //////////////////////////////////////////////////////////////////////

            update();

            var windowWidth = $(window).width();
            $(window).on('resize', function(){
                if ( $(window).width() != windowWidth ) {
                    flickity.resize();
                    windowWidth = $(window).width();
                }
            });
            
        });
    }

    subscriptionPageStickyHeader();

});

jQuery( window ).resize(function() {
    init(jQuery);
});

jQuery( window ).scroll(function() {
    if (jQuery('.section-subscription-progress').length == 0) {
        var callback = setHeaderBottom();
        throttle(callback, 50);
    }

    subscriptionPageStickyHeader();
});

function init($) {
    if($('.blocks-content-image.block-image-type--polaroid_parallax').length){
        let multiplier = 1.3
        if($( window ).width() < 576){
            multiplier = 1.5;
        }else if($( window ).width() >= 576 && $( window ).width() < 1200){
            multiplier = 1.2;
        }
        $('.blocks-content-image.block-image-type--polaroid_parallax').each(function(){
            if($(this).find('img').length){
                let blockContent = $(this);
                let imgheight = 0;
                $(this).find('img').each(function(){
                    if($(this).outerHeight() > imgheight){
                        imgheight = $(this).outerHeight();
                    }
                })
                blockContent.css('min-height', (imgheight*multiplier));
            }
        })
    }

    /*if(!window.mobileAndTabletCheck()){

        window.productZoom = $('[data-zoom]').each(function(){
            new Drift($(this)[0], {
                inlinePane: true,
                zoomFactor: 2,
                handleTouch: false
            });
        })

    }else if (window.productZoom) {

        window.productZoom.destroy();

    }*/

}

// (function(ns, fetch) {
//     if (typeof fetch !== 'function') return;

//     ns.fetch = function() {
//         const response = fetch.apply(this, arguments);

//         response.then(res => {
//             const resURL = new URL(res.url)
//             //console.log(resURL.pathname)
//             if ([
//                     `/cart/add.js`,
//                     `/cart/update.js`,
//                     `/cart/change.js`,
//                     `/cart/clear.js`,
//                     `/cart/add`,
//                     `/cart/update`,
//                     `/cart/change`,
//                     `/cart/clear`
//                 ].includes(resURL.pathname)) {
//                 //console.log('CALL TO CART URL');
//                 return res.clone().json().then(cartUpdate());
//             }
//         }).catch(e => console.error(e.message));

//         return response;
//     }

// }(window, window.fetch));

// async function cartUpdate(){

//     //console.log('RUNNING CART UPDATE');

//     //var attributes = JSON.parse(localStorage.getItem('attributes')) || {};

//     //console.log('cartUpdate');

//     fetch('/cart.js', {
//       headers: {
//         'Content-Type': 'application/json'
//       }
//     })
//     .then(response => response.json())
//     .then(async function(cart){

//         //console.log('cart', cart);

//         let allCodes = document.querySelectorAll('[data-cart-code-check]')

//         let applied = false;

//         let allDiscountCodes = [];

//         for (const discountCodeData of allCodes) {
//             var discountCodeDataHtml = jQuery(discountCodeData).html();
//             var discountCode = JSON.parse(atob(discountCodeDataHtml));
//             allDiscountCodes.push(discountCode.code);
//         }

//         //console.log('allDiscountCodes', allDiscountCodes);

//         for (const code of allCodes) {

//             if(applied == true) continue;

//             var codeData = jQuery(code).html();

//             discountCode = JSON.parse(atob(codeData));

//             var productFilters = code.dataset.cartCodeCheckProducts;

//             productFilters = productFilters.trim().replace(/(^,)|(,$)/g, '').split(",").filter(n => n);

//             //console.log(productFilters);

//             if(discountCode){

//                 var minimum_spend = discountCode.min_spend > 0 ? discountCode.min_spend : 0;
//                 var minimum_items = discountCode.min_items > 0 ? discountCode.min_items : 0;
//                 var check = false;

//                 var calculate_spend = 0;
//                 var calculate_items = 0;

//                 if(discountCode.apply_to == 'oneoff'){

//                     calculate_spend = 0;
//                     calculate_items = 0;

//                     for (let i = 0; i < cart.items.length; i++) {
//                       if(!('selling_plan_allocation' in cart.items[i])){
//                         if(productFilters.length > 0 && !productFilters.includes(cart.items[i].product_id.toString())){
//                             // console.log('skip1');
//                             continue;
//                         }
//                         // console.log('item', cart.items[i]);
//                         calculate_spend += cart.items[i].final_price*cart.items[i].quantity;
//                         calculate_items += cart.items[i].quantity;
//                       }
//                     }

//                     calculate_spend = calculate_spend / 100;

//                     if (calculate_items >= minimum_items && calculate_spend >= minimum_spend){
//                       check = true;
//                     }

//                 }else if(discountCode.apply_to == 'subscription'){

//                     calculate_spend = 0;
//                     calculate_items = 0;
                    
//                     for (let i = 0; i < cart.items.length; i++) {
//                       if('selling_plan_allocation' in cart.items[i]){
//                         if(productFilters.length > 0 && !productFilters.includes(cart.items[i].product_id.toString())){
//                             // console.log('skip2');
//                             continue;
//                         }
//                         //console.log('item', cart.items[i]);
//                         calculate_spend += cart.items[i].final_price*cart.items[i].quantity;
//                         calculate_items += cart.items[i].quantity;
//                       }
//                     }

//                     calculate_spend = calculate_spend / 100;

//                     if (calculate_items >= minimum_items && calculate_spend >= minimum_spend){
//                         check = true;
//                     }

//                 }else{

//                     calculate_spend = 0;
//                     calculate_items = 0;

//                     // console.log(productFilters.length);
//                     // console.log(productFilters);

//                     for (let i = 0; i < cart.items.length; i++) {
//                         // console.log('ID', cart.items[i].product_id);
//                         // console.log('includes', productFilters.includes(cart.items[i].product_id.toString()))
//                         if(productFilters.length > 0 && !productFilters.includes(cart.items[i].product_id.toString())){
//                             // console.log('skip');
//                             continue;
//                         }else{
//                             // console.log('continue');
//                         }
//                         calculate_spend += cart.items[i].final_price*cart.items[i].quantity;
//                         calculate_items += cart.items[i].quantity;
//                     }

//                     calculate_spend = calculate_spend / 100;

//                     // console.log('CI', calculate_items, 'MI', minimum_items, 'CS', calculate_spend, 'MS', minimum_spend)

//                     if(calculate_items >= minimum_items && calculate_spend >= minimum_spend){
//                         check = true;
//                     }

//                 }

//                 // console.log('check', check);

//                 var codeCookieValue = sessionStorage.getItem("jicActiveDiscountCode") || '';

//                 try {
                
//                     if(codeCookieValue.length > 0){
//                         codeCookieValue = JSON.parse(codeCookieValue);
//                         codeCookieValue = codeCookieValue.code;
//                     }

//                 } catch (error) {

//                     codeCookieValue = ''
//                     sessionStorage.removeItem("jicActiveDiscountCode");

//                 }

//                 if(check && codeCookieValue == discountCode.code){

//                     console.log(codeCookieValue.toUpperCase()+' already applied');

//                     await updateCheckoutSession(discountCode.code, cart);

//                     applied = true

//                 }else if(check && codeCookieValue !== discountCode.code && allDiscountCodes.includes(discountCode.code)){

//                     await updateCheckoutSession(discountCode.code, cart);

//                     await Promise.any([
//                         fetch(`/checkout?discount=${discountCode.code}`).catch(e => console.error(e.message)),
//                         fetch(`/discount/${discountCode.code}`).catch(e => console.error(e.message))
//                     ]).then(() => {
//                         //window.SLIDECART_APPLY_DISCOUNT(discountCode.code);
//                         console.log(discountCode.code.toUpperCase()+' applied');
//                         sessionStorage.setItem("jicActiveDiscountCode", JSON.stringify(discountCode));
//                         document.dispatchEvent(new CustomEvent('cartrefresh'));
//                         applied = true;
//                     }).catch(() => console.error(discountCode.code.toUpperCase()+' failed to apply'))

//                 }else if(!check && codeCookieValue == discountCode.code){

//                     await updateCheckoutSession(discountCode.code, cart);

//                 }

//                 //     console.log('nothing here');

//                 // }//else if(!check && codeCookieValue == discountCode.code){

//                 //     await fetch('/checkout?discount=+')
//                 //     .catch(e => console.error(e.message))
//                 //     .finally(() => {
//                 //         document.dispatchEvent(new CustomEvent('cartrefresh'));
//                 //         sessionStorage.removeItem("jicActiveDiscountCode")
//                 //     })

//                 // }

//             }

//         }

//     }).catch(e => console.error(e.message));

// }

// async function updateCheckoutSession(discountCode, cart){

//     const t = document.getElementById("shopify-features").innerHTML, n = JSON.parse(t);
    
//     const accessToken = n.accessToken;

//     const checkout = sessionStorage.getItem("jicCheckout");

//     const walletData = { checkout: { country: window.Shopify.country, discount_code: discountCode, line_items: cart.items, presentment_currency: cart.currency } };

//     let wallet;

//     if(checkout && checkout.length > 0){

//         //console.log('parsed', JSON.parse(checkout));

//         let checkoutToken = (JSON.parse(checkout)).checkout.token;

//         wallet = fetch(`/wallets/checkouts/${checkoutToken}`, { body: JSON.stringify(walletData), method: "PUT", "referrer": "http://127.0.0.1:9292/", referrerPolicy: "strict-origin-when-cross-origin", headers: { Authorization: "Basic ".concat(btoa(accessToken)), Accept: "*/*", "Content-Type": "application/json", referrerpolicy: "no-referrer" } })

//     }else{

//         wallet = fetch(`/wallets/checkouts`, { body: JSON.stringify(walletData), method: "POST", "referrer": "http://127.0.0.1:9292/", referrerPolicy: "strict-origin-when-cross-origin", headers: { Authorization: "Basic ".concat(btoa(accessToken)), Accept: "*/*", "Content-Type": "application/json", referrerpolicy: "no-referrer" } })

//     }

//     return wallet.then((response) => {
//         if (!response.ok) {
//             throw new Error('Failed to update / create checkout');
//         }
//         return response.json();
//     }).then((wallet) => {

//         const walletJSON = JSON.stringify(wallet);

//         sessionStorage.setItem("jicCheckout", walletJSON);

//         window.dispatchEvent(new CustomEvent('discountsupdated'));

//         return wallet;

//     }).catch((error) => {

//         console.error('There has been a problem with your fetch operation:', error);
//         return false;

//     });

// }

// window.settingFreeGiftItems = false;

// function setFreeGiftItems($){

//     console.log('setFreeGiftItems($);');

//     if(window.settingFreeGiftItems) return true;

//     window.settingFreeGiftItems = true;

//     fetch('/cart.js', {
//       headers: {
//         'Content-Type': 'application/json'
//       }
//     })
//     .then(response => response.json())
//     .then((cart) => {

//         console.log(cart.items);

//         var subscription_items = 0;
                        
//         for (let i = 0; i < cart.items.length; i++) {
//             if('selling_plan_allocation' in cart.items[i]){
//                 subscription_items += cart.items[i].quantity;
//             }
//         }

//         // if(subscription_items < 1){

//         //     console.log('clearing freecase');

//         //     // Grab the attributes from local storage
//         //     var attributes = JSON.parse(localStorage.getItem("attributes")) || {};

//         //     // Set the new local storage value
//         //     delete attributes.freegift;// = $(this).val();

//         //     localStorage.setItem("attributes", JSON.stringify(attributes));

//         // }

//         if(subscription_items > 0 || window.location.href.indexOf("subscription/") > -1){

//             console.log('STAGE 1');

//             $('.gift-option').each(function(){

//                 var attributes = JSON.parse(localStorage.getItem('attributes')) || {};

//                 console.log('STAGE 2');

//                 $(this).show();

//                 // Check that we've get some available free gift cases
//                 if($(this).find('[data-add-free-gift]').length){

//                     console.log('STAGE 3');

//                     // We've got subscription items in the basket, so show the box
//                     $(this).show();

//                     console.log('STAGE 3.1');

//                     // And set the field name to attributes[freegift] so it's picked up by shopify
//                     $(this).find('[data-add-free-gift]').first().addClass('test').attr('name', 'attributes[freegift]');

//                     console.log('STAGE 3.2');

//                     console.log('attributes', attributes);

//                     // Check if we have already got a case selected
//                     if(attributes && 'freegift' in attributes && attributes.freegift.length > 0){
//                         console.log('STAGE 3.3');
//                         $(this).find('[data-add-free-gift]').first().val(attributes.freegift);
//                     }else{
//                         console.log('STAGE 3.4');
//                     }

//                     console.log('STAGE 4');

//                     console.log($(this).find('[data-add-free-gift]'));

//                     // Reset the change listener...
//                     $(this).find('[data-add-free-gift]').first().unbind('change').on('change', function() {

//                         clearTimeout(window.addedMessageTimeout);

//                         console.log('STAGE 5');

//                         console.log('Adding attributes');
                        
//                         // Grab the attributes from local storage
//                         var attributes = JSON.parse(localStorage.getItem("attributes")) || {};
                        
//                         // Check if one is already set for using the message later
//                         var change = 'freegift' in attributes && attributes.freegift.length > 0 ? true : false;

//                         // Set the new local storage value
//                         attributes.freegift = $(this).val();

//                         localStorage.setItem("attributes", JSON.stringify(attributes));

//                         // Show a confirmation message to the end user.
//                         var addedMessage = $(this).parent().siblings('.add-free-gift-message')

//                         if(attributes.freegift == "invalid"){

//                             addedMessage.text('Unfortunately, as you\'ve already had a gift, you\'re not eligible to receive another subscription gift - sorry!');
                            
//                             $(this).attr('disabled', 'disabled').parent('.select').fadeOut();

//                             addedMessage.slideDown(200);
                        
//                         }else{

//                             if(change && attributes.freegift == ""){
//                                 addedMessage.text('Your free gift has been removed');
//                             }else if(change){
//                                 addedMessage.text('Your free gift has been changed');
//                             }else{
//                                 addedMessage.text('Your free gift has been added');
//                             }

//                             addedMessage.slideDown(200);

//                             window.addedMessageTimeout = setTimeout(function(){
//                                 addedMessage.slideUp(200);
//                             }, 5000);

//                         }

//                         // Trigger this function again.
//                         return setFreeGiftItems($);
//                     });

//                 }

//                 attributes = JSON.parse(localStorage.getItem('attributes')) || {};

//                 if($(this).find('#add-free-gift-title').length && 'freegift' in attributes && attributes.freegift.length > 0 && attributes.freegift != "invalid"){
//                     $(this).find('#add-free-gift-title').text('Your chosen subscription gift');
//                 }else{
//                     $(this).find('#add-free-gift-title').text('Choose a subscription free gift');
//                 }

//             });

//             // $('.hidden-cart-attribute').remove();

//             // $('#cart-attributes-data').each(function(){

//             //     var html = '';

//             //     Object.keys(attributes).forEach(function(key) {
//             //         html = html + "<input type='hidden' class='hidden-cart-attribute' name='attributes["+key+"]' value='"+attributes[key]+"' />";
//             //     });

//             //     $(this).html(html);

//             // });

//             // Then display the correct free gift item in the cart contents.
//             $('table.cart-items').each(function(){

//                 var attributes = JSON.parse(localStorage.getItem('attributes')) || {};

//                 var freeGiftTemplateName = $(this).parents('.drawer__cart-items-wrapper').length > 0 ? 'data-free-case-template-minicart' : 'data-free-case-template';

//                 if($('['+freeGiftTemplateName+']').length && $(this).length && 'freegift' in attributes && attributes.freegift.length > 0){

//                     $(this).find('tr.cart-item-free-gift').remove();

//                     fetch('/products/'+attributes.freegift+'.json')
//                     .then(response => response.json())
//                     .then((product) => {

//                         var freeCaseTemplate = $('['+freeGiftTemplateName+']').html();
//                         var tr = freeCaseTemplate.interpolate({ product: product.product });

//                         $(this).find('tbody').append(tr);

//                     })
//                     .catch(e => console.error(e.message));

//                 }

//             });

//         }else{

//             $('.gift-option').hide();
//             $('#add-free-gift').attr('name', 'attributes_ignore[freegift]');
//             $('tr.cart-item-free-gift').remove();

//         }

//         window.settingFreeGiftItems = false;

//     }).catch((e) => window.settingFreeGiftItems = false);

// }

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera); // eslint-disable-line
  return check;
};

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera); // eslint-disable-line
  return check;
};

document.addEventListener('DOMContentLoaded', function () {
    window.BOLD = window.BOLD || {};
    window.BOLD.BsubWidget = new BsubWidget();
    window.BOLD.BsubWidget.init();
    window.BOLD.SubscriptionBuilder = new SubscriptionBuilder();
    window.BOLD.SubscriptionBuilder.init();
    window.BOLD.SubscriptionModifier = new SubscriptionModifier();
    window.BOLD.SubscriptionModifier.init();
});
